

import React, { useEffect, useState, useContext } from 'react';
import { Box, Typography } from '@mui/joy';
import { supabase } from '../../supabaseClient';
import { AuthContext } from '../../context/AuthContext.jsx';
import StyledTable from '../components/StyledTable';

const ClientSubmittals = () => {
  const { user } = useContext(AuthContext);
  const [projects, setProjects] = useState([]);
  const [submittals, setSubmittals] = useState([]);

  useEffect(() => {
    if (!user?.id) return;

    const fetchProjects = async () => {
      const { data: userClients, error: userClientError } = await supabase
        .from('user_clients')
        .select('client_id')
        .eq('user_id', user.id);

      if (userClientError) {
        console.error('Error fetching user clients:', userClientError);
        return;
      }

      const clientIds = userClients.map(entry => entry.client_id);

      const { data: projData, error: projError } = await supabase
        .from('projects')
        .select('id, name')
        .in('client_id', clientIds);

      if (projError) {
        console.error('Error fetching projects:', projError);
        return;
      }

      setProjects(projData || []);
    };

    fetchProjects();
  }, [user]);

  useEffect(() => {
    if (!projects.length) return;

    const projectIds = projects.map(p => p.id);

    const fetchSubmittals = async () => {
      const { data: submittalData, error: submittalError } = await supabase
        .from('submittal_schedule')
        .select('id, name, project_id, submittal_date')
        .in('project_id', projectIds);

      if (submittalError) {
        console.error('Error fetching submittals:', submittalError);
        return;
      }

      const formatted = submittalData.map(s => {
        const project = projects.find(p => p.id === s.project_id);
        return {
          ...s,
          project_name: project?.name || 'Unknown Project',
          submittal_date: s.submittal_date ? new Date(s.submittal_date).toLocaleDateString('en-US') : '—',
        };
      });

      setSubmittals(formatted);
    };

    fetchSubmittals();
  }, [projects]);

  if (!submittals.length) {
    return (
      <Typography level="body2" textAlign="center" sx={{ mt: 4 }} color="success">
        No submittals found for your projects.
      </Typography>
    );
  }

  return (
    <Box sx={{ p: 3, backgroundColor: '#f7f9fc', borderRadius: 8, boxShadow: 'sm', mt: 4 }}>
      <Typography level="h4" sx={{ mb: 2, color: 'success.700' }}>
        Project Submittals
      </Typography>
      <StyledTable
        columns={[
          { key: 'project_name', label: 'Project' },
          { key: 'name', label: 'Submittal' },
          { key: 'submittal_date', label: 'Submittal Date' }
        ]}
        rows={submittals}
      />
    </Box>
  );
};

export default ClientSubmittals;